import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { RoleType } from '@addmile/backend-client';

interface HubStore {
  searchUserData: { id: string; email: string };
  user: { email: string; role: RoleType | null } | null;
}

export const useHubStore = create<HubStore>()(
  persist(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    immer((_set) => ({
      searchUserData: { id: '', email: '' },
      user: { email: '', role: null },
    })),
    {
      name: 'hub-storage',
    },
  ),
);
